import { render, staticRenderFns } from "./BusynessCard.vue?vue&type=template&id=1ec14e30&scoped=true"
import script from "./BusynessCard.vue?vue&type=script&lang=js"
export * from "./BusynessCard.vue?vue&type=script&lang=js"
import style0 from "./BusynessCard.vue?vue&type=style&index=0&id=1ec14e30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec14e30",
  null
  
)

export default component.exports